<button *ngIf="options?.showGoBackButton"
    id="back-button"
    [attr.data-testid]="testIdContext ? 'FormButtons-' + testIdContext + '-BackButton' : 'FormButtons-BackButton'"
    type="button"
    class="btn standard-width gray-lt config-form-button spaced-left"
    (click)="backOutput.emit()">

    {{ 'generics.go-back' | translate }}
</button>

<button *ngIf="options?.actionButton"
    type="button"
    class="btn standard-width gray-lt config-form-button spaced-left"
    [ngClass]="options.actionButton.class"
    (click)="options.actionButton.action()">
    
    {{ options.actionButton.textKey | translate }}
</button>

<button *ngIf="options?.showDeleteButton"
    id="delete-button"
    type="button" 
    class="btn standard-width gray-lt config-form-button asFE spaced-left"
    (click)="deleteOutput.emit()">

    {{ (options?.deleteTextKey ? options.deleteTextKey : 'generics.delete') | translate }}
</button>

<button *ngIf="options?.showCancelButton"
    id="cancel-button"
    type="button" 
    class="btn standard-width gray-lt config-form-button asFE"
    (click)="cancelOutput.emit()"
    [attr.data-testid]="testIdContext ? 'FormButtons-' + testIdContext + '-CancelButton' : 'FormButtons-CancelButton'">

    {{ 'generics.cancel' | translate }}
</button>

<app-dropdown-action-button
    *ngIf="options?.showSubmitButton && dropdownActionButtonOptions"
    [options]="dropdownActionButtonOptions"
/>

<button
    *ngIf="options?.showSubmitButton && !dropdownActionButtonOptions"
    id="submit-button"
    [type]="options?.enterSubmits ? 'submit' : 'button'"
    class="btn standard-width blue-lt config-form-button spaced-right"
    [disabled]="options?.submitDisabled || options?.submitLoading"
    (click)="submitOutput.emit()"
    [attr.data-testid]="testIdContext ? 'FormButtons-' + testIdContext + '-SaveButton' : 'FormButtons-SaveButton'"
>
        
    <span
        *ngIf="!options?.submitLoading" 
        [ngClass]="{ 'button-text-span': options?.submitButtonDropdown && options.submitButtonDropdown.length > 0 }"
    >
        {{ (options?.submitTextKey ? options.submitTextKey : 'generics.save') | translate }}
    </span>
    <span
        *ngIf="options?.submitLoading"
        class="loading-circle"
    >
        <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
    </span>
</button>
